import axios from 'axios';
import moment from 'moment';

let redirectIndex = function(that, error) {
    //check if error is because of the expired token
    if (error && error.response && error.response.status){
        let status = error.response.status;
        if (status === 401){
            //force the user to logout since the token has expired.
            localStorage.clear();
            if (that && that.$bvToast) {
                that.$bvToast.toast(
                    "Your session has expired. Please login again.", 
                    {title: "Session Expired", autoHideDelay: 1500, variant:"warning"}
                );
            }
            window.location.href = "/";
            return
        }
        else {
            return
        }
    }
    return
}

function isTokenExpired(token) {
    if (!token) return true;
    
    try {
        // Decode JWT token
        const payload = JSON.parse(atob(token.split('.')[1]));
        const currentTime = Math.floor(Date.now() / 1000);
        
        // Check if token has expired (with 1-minute buffer)
        return payload.exp < currentTime;
    } catch (error) {
        // If we can't decode the token, consider it expired
        return true;
    }
}

// Helper function to handle token expiration
function handleTokenExpiration(self) {
    localStorage.clear();
    if (self && self.$bvToast) {
        self.$bvToast.toast(
            "Your session has expired. Please login again.",
            {title: "Session Expired", autoHideDelay: 1500, variant:"warning"}
        );
    }
    window.location.href = "/";
}

let Requestor = {
    moment: function(){
        return moment();
    },
    numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    
    // Public methods (no token required)
    postAsync: async function(path, data, s, f) {
        try{
            let response = await axios.post(path, data);
            if (!s){
                return response;
            }
            else {
                s(response);
            }
        }
        catch (error) {
            if (!f){
                console.log(error);
            }
            else {
                f(error);
            }
        }
    },
    
    postSync: function(path, data, s, f) {
        axios({url: path, method: "post", data: data}, {timeout: 60})
        .then(function (response) {
            if(!s) {
                return response;
            }
            else {
                s(response);
            }
        })
        .catch(function (error) {
            if (!f){
                console.log(error);
            }
            else {
                f(error);
            }
        });
    },
    
    getAsync: async function(path, data, s, f) {
        try{
            let response = await axios.get(path, { params: data});
            if (!s){
                return response;
            }
            else {
                s(response);
            }
        }
        catch (error) {
            if (!f){
                console.log(error);
            }
            else{
                f(error);
            }
        }
    },
    
    getSync: function(path, data, s, f) {
        let config = {
            params: data
        }
        axios.get(path, config)
        .then(function (response) {
            if(!s) {
                return response;
            }
            else {
                s(response);
            }
        })
        .catch(function (error) {
            if (!f){
                console.log(error);
            }
            else {
                f(error);
            }
        });
    },
    
    // Protected methods (require token)
    postAsyncP: async function(path, data, self, s, f) {
        // Check token expiration before making request
        const token = localStorage.getItem('userToken');
        if (isTokenExpired(token)) {
            handleTokenExpiration(self);
            return;
        }
        
        try{
            let headers = { Authorization: 'Bearer '+localStorage.userToken };
            let response = await axios.post(path, data, {headers: headers});
            if (!s) {
                return response;
            }
            else {
                s(response);
            }
        }
        catch (error) {
            if (error) {
                if (error.response){
                    //logout and redirect to index if the token expired
                    redirectIndex(self, error);
                
                    if (!f){
                        console.log(error);
                        return
                    }
                    else {
                        f(error);
                    }
                }
                else {
                    if (!f){
                        console.log(error);
                        return
                    }
                    else {
                        f(error);
                    }
                }
            }
            else {
                if (!f){
                    console.log(error);
                    return
                }
                else {
                    f(error);
                }
            }
        }
    },
    
    postSyncP: function(path, data, self, s, f) {
        // Check token expiration before making request
        const token = localStorage.getItem('userToken');
        if (isTokenExpired(token)) {
            handleTokenExpiration(self);
            return;
        }
        
        let headers = { Authorization: 'Bearer '+localStorage.userToken };
        axios.post(path, data, {headers: headers}, {timeout: (data.timeout || 60) })
        .then((response) => {
            if (!s){
                return response;
            }
            else {
                s(response);
            }
        })
        .catch((error) => {
            if (error) {
                if (error.response){
                    //logout and redirect to index if the token expired
                    redirectIndex(self, error);
                
                    if (!f){
                        console.log(error);
                        return
                    }
                    else {
                        f(error);
                    }
                }
                else {
                    if (!f){
                        console.log(error);
                        return
                    }
                    else {
                        f(error);
                    }
                }
            }
            else {
                if (!f){
                    console.log(error);
                    return
                }
                else {
                    f(error);
                }
            }
        });
    },
    
    getAsyncP: async function(path, data, self, s, f){
        // Check token expiration before making request
        const token = localStorage.getItem('userToken');
        if (isTokenExpired(token)) {
            handleTokenExpiration(self);
            return;
        }
        
        try{
            if (!data){
                data = {};
            }

            let headers = { Authorization: 'Bearer '+localStorage.userToken };
            let response = await axios.get(path, { params: data, headers: headers });

            if (!s){
                return response;
            }
            else{
                s(response);
            }
       
        }
        catch (error) {
            if (error) {
                if (error.response){
                    //logout and redirect to index if the token expired
                    redirectIndex(self, error);
                
                    if (!f){
                        console.log(error);
                        return
                    }
                    else {
                        f(error);
                    }
                }
                else {
                    if (!f){
                        console.log(error);
                        return
                    }
                    else {
                        f(error);
                    }
                }
            }
            else {
                if (!f){
                    console.log(error);
                    return
                }
                else {
                    f(error);
                }
            }
        }
    },
    
    getSyncP: function(path, data, self, s, f) {
        // Check token expiration before making request
        const token = localStorage.getItem('userToken');
        if (isTokenExpired(token)) {
            handleTokenExpiration(self);
            return;
        }
        
        let headers = { Authorization: 'Bearer '+localStorage.userToken };
        let config = {
            headers: headers,
            params: data
        }
        axios.get(path, config)
        .then(function(response) {
            if (!s){
                console.log(response);
            }
            else {
                s(response);
            }
        })
        .catch(function(error){
            if (error) {
                if (error.response){
                    //logout and redirect to index if the token expired
                    redirectIndex(self, error);
                
                    if (!f){
                        console.log(error);
                        return
                    }
                    else {
                        f(error);
                    }
                }
                else {
                    if (!f){
                        console.log(error);
                        return
                    }
                    else {
                        f(error);
                    }
                }
            }
            else {
                if (!f){
                    console.log(error);
                    return
                }
                else {
                    f(error);
                }
            }
        });
    },
    
    // Utility methods
    sort: function(array, key, mapper){
        if(mapper){
            return array.sort((a,b) => (mapper[a[key]] > mapper[b[key]]) ? 1 : ((mapper[b[key]] > mapper[a[key]]) ? -1 : 0));     
        }
        else{
            return array.sort((a,b) => (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0)); 
        }
        
    },
    
    sort_reverse: function(array, key, mapper){
        if(mapper){
            return array.sort((a,b) => (mapper[b[key]] > mapper[a[key]]) ? 1 : ((mapper[a[key]] > mapper[b[key]]) ? -1 : 0));
        }
        else {
            return array.sort((a,b) => (b[key] > a[key]) ? 1 : ((a[key] > b[key]) ? -1 : 0));
        }
    }
}

export default Requestor;


// WEBPACK FOOTER //
// ./src/utilities/Requestor.js